import styled from "@emotion/styled/macro";
import {FormControl} from "@mui/material";

export const FormContainer = styled.div`
	display: flex;
	align-items: center;
	flex-direction: column;
	max-width: 320px;
	margin: 0 auto;
`;

// Used as a wrapper for a form element, to update styles or add margin.
export const FormField = styled(FormControl)`
	&.MuiFormControl-root {
		width: 100%;
		margin-bottom: 16px;
	}
`;

export const FormError = styled.div`
	color: ${({theme}) => theme.colorPalette.primary};
`;
